import React, { useState } from 'react';
import { useStoreMap } from 'effector-react';
import { toFlag } from 'pano-utils';
import {
  $sceneMap,
  $sceneMapApi,
  $tourData,
  $tourDataApi,
} from '@stores/dataStores';
import CategoryConfigBase from './CategoryConfigBase';

function PanelCategoryConfig() {
  const categoryConfig = useStoreMap({
    store: $tourData,
    keys: [],
    fn: (state) => state.categoryConfig,
  });
  const [defaultHiddenSet] = useState(() => {
    const ids = [...$sceneMap.getState().values()]
      .filter((x) => x.showThumb === 0)
      .map((x) => x.id);
    return new Set(ids);
  });
  return (
    <CategoryConfigBase
      defaultValue={categoryConfig}
      defaultHiddenSet={defaultHiddenSet}
      onConfirm={({ config, hiddenIdSet }) => {
        $sceneMapApi.update((draft) => {
          draft.forEach((item) => {
            item.showThumb = toFlag(!hiddenIdSet.has(item.id));
          });
        });
        $tourDataApi.update((draft) => {
          draft.categoryConfig = config;
        });
      }}
    />
  );
}

export default PanelCategoryConfig;
